// extracted by mini-css-extract-plugin
export default {"body":"NewsDetail_body__56MCL"};